const docFields = {
  fields: "Поля",
  formFields: "Поля формы",
  addField: "Добавить поле",
  noFields: "Нет полей — добавьте поля для заполнения",
  label: "Метка",
  placeholder: "Подсказка",
  options: "Варианты",
  option: "Вариант",
  addOption: "Добавить вариант",
  required: "Обязательное поле",
} as const;
export default docFields;
